export const CERTITICATE = 'Certificate';
export const DIPLOMA = 'Diploma';
export const UNDERGRADUATE_DEGREE = 'Undergraduate Degree';
export const POSTGRADUATE_DEGREE = 'Postgraduate Degree';

export const CERTITICATE_LABEL = 'Certificates';
export const DIPLOMA_LABEL = 'Diploma';
export const UNDERGRADUATE_DEGREE_LABEL = 'Undergraduate Degrees';
export const POSTGRADUATE_DEGREE_LABEL = 'Postgraduate Degrees';

export const QUALIFICATION_TYPE = [
  CERTITICATE,
  DIPLOMA,
  UNDERGRADUATE_DEGREE,
  POSTGRADUATE_DEGREE,
];
export const QUALIFICATION_TYPE_SELECT_OPTIONS = [
  {
    label: CERTITICATE_LABEL,
    value: CERTITICATE,
  },
  {
    label: DIPLOMA_LABEL,
    value: DIPLOMA,
  },
  {
    label: UNDERGRADUATE_DEGREE_LABEL,
    value: UNDERGRADUATE_DEGREE,
  },
  {
    label: POSTGRADUATE_DEGREE_LABEL,
    value: POSTGRADUATE_DEGREE,
  },
];
